module.exports = __webpack_public_path__ + "static/media/home.bf7fbce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home.jpg
// module id = 1262
// module chunks = 37